import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { apiStore } from '@/stores/ApiStore';
import {
  buildAttConversionClickPayload,
  persistAttParams,
  wasConversionClickSent,
  setConversionClickSent,
} from '@/utils/attParams';
import { readBrowserSessionCode } from '@/utils/sessionEnvironment';

/**
 * Собирает параметры att_* из query string, сохраняет в sessionStorage
 * и после завершения рендеринга страницы отправляет POST /v1/conversion/click с телом из att_ параметров.
 * В сессии отправка выполняется не более одного раза (флаг в sessionStorage).
 * Работает одинаково в браузере и WebView.
 */
export function AttParamsTracker() {
  const location = useLocation();
  const sentForCurrentParams = useRef<string | null>(null);

  useEffect(() => {
    const params = persistAttParams(location.search);
    if (!params || Object.keys(params).length === 0) {
      sentForCurrentParams.current = null;
      return;
    }

    if (readBrowserSessionCode()) {
      return;
    }

    const payload = buildAttConversionClickPayload(params);
    if (!payload) {
      return;
    }

    const paramsKey = JSON.stringify(payload);
    if (sentForCurrentParams.current === paramsKey) {
      return;
    }
    if (wasConversionClickSent(payload)) {
      return;
    }
    sentForCurrentParams.current = paramsKey;

    const sendConversionClick = () => {
      apiStore.conversionClick(payload as Record<string, unknown>)
        .then(() => setConversionClickSent(payload))
        .catch((err) => {
          console.warn('Не удалось отправить conversion/click', err);
          sentForCurrentParams.current = null;
        });
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(sendConversionClick);
    });
  }, [location.search]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const initialSearch = window.location.search;
    if (!initialSearch) {
      return;
    }

    const params = persistAttParams(initialSearch);
    if (!params || Object.keys(params).length === 0) {
      return;
    }

    if (readBrowserSessionCode()) {
      return;
    }

    const payload = buildAttConversionClickPayload(params);
    if (!payload) {
      return;
    }

    const paramsKey = JSON.stringify(payload);
    if (sentForCurrentParams.current === paramsKey) {
      return;
    }
    if (wasConversionClickSent(payload)) {
      return;
    }
    sentForCurrentParams.current = paramsKey;

    const sendConversionClick = () => {
      apiStore.conversionClick(payload as Record<string, unknown>)
        .then(() => setConversionClickSent(payload))
        .catch((err) => {
          console.warn('Не удалось отправить conversion/click', err);
          sentForCurrentParams.current = null;
        });
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(sendConversionClick);
    });
  }, []);

  return null;
}
